"use client";

export { default as Modal } from "./modal"